import React from "react"

import imgPlanetaLoving from "./../../../assets/images/packaging-delivery/performance/planeta_loving.webp"

import "./packaging-delivery-section-3.scss"

function PackagingDeliverySection3() {
  return (
    <div className="f-packaging-delivery-section-3">
      <div className="f-packaging-delivery-section-3__container">
        <img
          className="f-packaging-delivery-section-3__img"
          src={imgPlanetaLoving}
          alt="Sobre con empaques y el planeta tierra"
        />
        <div className="f-packaging-delivery-section-3__text">
          <h2 className="f-packaging-delivery-section-3__text__title">
            Descubre cómo con tu ayuda, damos más{" "}
            <span className="f-packaging-delivery-section-3__text__title__yellow-fill">
              Loving al planeta
            </span>
          </h2>
          <p className="f-packaging-delivery-section-3__text__paragraph-1">
            ¡Bienvenida a la economía circular!
          </p>
          <p className="f-packaging-delivery-section-3__text__paragraph-2">
            Cuando envías tus empaques, estás ayudando a que el plástico o
            cartón de los mismos pueda ser{" "}
            <span className="f-packaging-delivery-section-3__text__paragraph-2__bold">
              aprovechado nuevamente, para crear muchas cosas nuevas.
              <br />
              <br />
              Ese es el principio de la economía circular: reciclar, y
              reutilizar para darle más Loving al planeta, súper ¿cierto?
            </span>
          </p>
          <p className="f-packaging-delivery-section-3__text__paragraph-3">
            Ahora mira lo que hacemos con tus empaques:
          </p>
        </div>
      </div>
    </div>
  )
}

export default PackagingDeliverySection3
